import PropTypes from 'prop-types';

import styles from './OnboardingViewBase.module.scss';

const OnboardingViewBase = ({ children }) => {
  return <div className={styles['OnboardingViewBase']}>{children}</div>;
};

OnboardingViewBase.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  children: PropTypes.any
};

export default OnboardingViewBase;
